<template>
  <div class="screen timediagrams" :class="[`${pageColor}-bg`]">
      <h1>time charts are coming soon.</h1>
      <p>train your inner clock by Developing a better feeling for duration through comparing the expected time with the time you needed.</p>
      <!--h1>be aware of how you spend your time.</h1-->
  </div>
</template>

<script>

export default {
  name: 'timediagrams',
  props: {
    pageColor: String,
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.screen
  background-image: linear-gradient(150deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  @media $desktop
    background-image: linear-gradient(-7deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  &.v-enter-active,
  &.v-leave-active
    transition: filter 80ms ease

    &.v-enter,
    &.v-leave-to
      filter: blur(1px);
  p
    font-family: futura-pt, serif;
    font-weight: 400;
    font-style: normal;
    text-transform: uppercase;
    padding-right: 40px
    padding-left: 40px

    @media $tablet
      margin-left: 160px
      width: 30%


</style>
